<template>
  <a :href="path">{{ text }}</a>
</template>

<script>
export default {
  name: "Link",
  props: {
    path: String,
    text: String,
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>